'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function flow() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var result = funcs.length ? funcs[0].apply(this, args) : args[0];
        for(var i = 1; i < funcs.length; i++){
            result = funcs[i].call(this, result);
        }
        return result;
    };
}
exports.flow = flow;
